import React, { useState } from "react";
import styles from "./PropertyView.module.css";
import InfoLineView, { InfoLine } from "../../Components/InfoLineView";
import { PropertyDTO } from "../../Networking/Interface/Account/AccountInterface";
import { FcLock, FcUnlock } from "react-icons/fc";
import { MdExpandMore, MdExpandLess } from "react-icons/md";

type PropertyViewProps = {
  properties: PropertyDTO[];
};

const removeHexColor = (propName: string | undefined): string => {
  if (!propName) {
    return "Unnamed Property";
  }
  const hexRegex = /\{[0-9A-Fa-f]+\}/g;
  return propName.replace(hexRegex, "");
};

const formatDate = (timestamp: number): string => {
  if (timestamp === 0) return "Never";
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString();
};

const PropertyCard: React.FC<{ property: PropertyDTO }> = ({ property }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={styles.propertyCard}>
      <div className={styles.cardHeader}>
        <div className={styles.titleArea}>
          <h3 className={styles.propName}>{removeHexColor(property.propName)}</h3>
          {property.address && <span className={styles.propAddress}>{property.address}</span>}
        </div>
        <span className={styles.lockIcon}>
          {property.locked ? <FcLock title="Locked" /> : <FcUnlock title="Unlocked" />}
        </span>
      </div>

      <div className={styles.summaryRow}>
        <span>${property.price.toLocaleString()}</span>
        <span className={styles.dot}>·</span>
        <span>Int {property.interior}</span>
      </div>

      <button
        className={styles.toggleBtn}
        onClick={() => setExpanded((prev) => !prev)}
      >
        {expanded ? <MdExpandLess size={16} /> : <MdExpandMore size={16} />}
        {expanded ? "Hide details" : "Show details"}
      </button>

      {expanded && (
        <div className={styles.detailsPane}>
          <InfoLineView title="Details">
            {property.address && <InfoLine label="Address" value={property.address} />}
            <InfoLine label="Value" value={`$${property.price.toLocaleString()}`} />
            <InfoLine label="Interior" value={property.interior} />
            {!!property.tax && <InfoLine label="Tax" value={`$${property.tax.toLocaleString()}`} />}
            {!!property.lastTaxDate && <InfoLine label="Last Tax Date" value={formatDate(property.lastTaxDate)} />}
          </InfoLineView>
        </div>
      )}
    </div>
  );
};

const PropertyView: React.FC<PropertyViewProps> = ({ properties }) => {
  return (
    <div className={styles.propertyList}>
      {properties.map((property) => (
        <PropertyCard key={property.id} property={property} />
      ))}
    </div>
  );
};

export default PropertyView;
